import Store from '@/store/computed/storeHelpers'
import BillingPeriodService from '@/services/requests/billingPeriodService'

export default {
  computed: {
    billingPeriods: Store.getSet({ store: 'settings', prop: 'billingPeriods' }),
    loadingBillingPeriods: Store.getSet({
      store: 'settings',
      prop: 'loadingBillingPeriods'
    }),
    openBillingPeriods() {
      return this.billingPeriods
        .filter(({ isOpen }) => isOpen)
        .map(({ name }) => name)
    },
    allBillingPeriods() {
      return this.billingPeriods.map(({ name }) => name)
    }
  },
  methods: {
    getBillingPeriods() {
      this.loadingBillingPeriods = true
      BillingPeriodService.getBillingPeriods()
        .then(result => {
          this.loadingBillingPeriods = false
          this.billingPeriods = result.data.result
        })
        .catch(err => {
          this.loadingBillingPeriods = false
          console.log(err)
          this.snackError()
        })
    }
  },
  mounted() {
    if (!this.billingPeriods.length) {
      this.getBillingPeriods()
    }
  },
  beforeDestroy() {
    this.billingPeriods = []
  }
}
